import React, { useEffect, useState } from 'react';
import { toolkitApi } from '../../services/toolkit';
import { MessageEditor } from './MessageEditor';

export function SavedMessages({ categoryTitles }) {
  const [messages, setMessages] = useState(null);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    toolkitApi.listMessages().then(setMessages);
  }, []);

  if (messages === null) {
    return <p className="text-sm text-slate-500 dark:text-slate-400">Loading…</p>;
  }
  if (open) {
    return (
      <MessageEditor
        message={open}
        onChange={(updated) => {
          setOpen(updated);
          setMessages(messages.map((m) => (m.id === updated.id ? updated : m)));
        }}
        onDone={() => setOpen(null)}
      />
    );
  }
  if (messages.length === 0) {
    return (
      <p className="text-sm text-slate-600 dark:text-slate-300">
        No saved requests yet — generate your first one from the New Request tab.
      </p>
    );
  }
  const remove = async (id) => {
    await toolkitApi.deleteMessage(id);
    setMessages(messages.filter((m) => m.id !== id));
  };
  return (
    <ul className="space-y-3">
      {messages.map((m) => (
        <li key={m.id}
          className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800">
          <button type="button" onClick={() => setOpen(m)} className="min-w-0 flex-1 text-left">
            <span className="block truncate font-semibold text-slate-900 dark:text-white">{m.subject}</span>
            <span className="mt-0.5 block text-xs text-slate-500 dark:text-slate-400">
              {categoryTitles[m.category] || m.category} · {new Date(m.created_at).toLocaleDateString()}
              {m.sent_date && (
                <span className="ml-2 rounded-full bg-emerald-100 px-2 py-0.5 font-semibold text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300">
                  Sent {m.sent_date}
                </span>
              )}
            </span>
          </button>
          <button type="button" onClick={() => remove(m.id)}
            className="rounded-lg px-3 py-1.5 text-xs font-medium text-slate-500 hover:bg-red-50 hover:text-red-600 dark:text-slate-400 dark:hover:bg-red-900/30">
            Delete
          </button>
        </li>
      ))}
    </ul>
  );
}
